import { SVGProps } from 'react'

export const SafeSvg = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      version='1.1'
      viewBox='0 0 1024 1024'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M889.81470547 251.34411729A1313.31176455 1313.31176455 0 0 1 590.53823545 87.99411729a131.66470547 131.66470547 0 0 0-157.0764709 0A1313.70882363 1313.70882363 0 0 1 134.15882363 251.34411729 30.01764727 30.01764727 0 0 0 114.91470547 279.05882363v246.49411729c0 213.35294092 338.8235291 436.42058818 397.05882363 436.42058819s397.05882363-223.09411729 397.05882363-436.42058819V279.05882363a30.01764727 30.01764727 0 0 0-19.24411728-27.71470634z m-252.18529365 248.32058818l-139.28823545 190.58823545a15.40588271 15.40588271 0 0 1-27.84705908-8.70882363v-118.50882276a15.19411729 15.19411729 0 0 0-15.35294092-15.00882364h-56.30294092a15.40588271 15.40588271 0 0 1-13.65882363-8.12647089 14.71764727 14.71764727 0 0 1 1.16470547-15.59117637l139.28823544-190.58823545a15.40588271 15.40588271 0 0 1 27.84705909 8.70882364v118.40294091a15.19411729 15.19411729 0 0 0 15.35294091 15.00882363h56.27647091a14.98235273 14.98235273 0 0 1 12.49411728 23.82352911z' />
    </svg>
  )
}
